import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-12 px-4 bg-brand-dark relative z-10" data-id="element-200">
      <div className="max-w-3xl mx-auto text-center" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-danger/30 p-6 sm:p-8 rounded-2xl shadow-[0_0_30px_rgba(239,68,68,0.1)]" data-id="element-202">
          <p className="text-xs font-black tracking-widest text-brand-danger uppercase mb-3" data-id="element-203">
            Il vero costo nascosto
          </p>
          <h2 className="text-2xl sm:text-3xl font-black text-brand-cream mb-5" data-id="element-204">
            Smetti di pagare con il tuo tempo libero.
          </h2>
          <p className="text-xs font-black tracking-widest text-brand-danger uppercase mb-3" data-id="element-205">
            200+ ore perse all'anno
          </p>
          <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-3" data-id="element-206">
            Progettare manualmente ogni lezione tecnica, schema elettrico e
            verifica ti toglie da{' '}
            <span className="text-brand-danger font-bold" data-id="element-207">
              4 a 6 ore a settimana
            </span>
            .
          </p>
          <p className="text-base sm:text-lg text-gray-400 leading-relaxed" data-id="element-208">
            Sono{' '}
            <span className="text-brand-danger font-bold" data-id="element-209">
              weekend, serate e tempo in famiglia
            </span>{' '}
            che non tornano più indietro.
          </p>
        </motion.div>
      </div>
    </section>;
}